import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const SettingsModule = lazy(loadModule);

export default SettingsModule;
